import { featuredTopic } from '@/mocks/heiLiao';

export default function TopicTimeline() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6">
      <div className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
        <div className="relative bg-gradient-to-r from-primary-500 to-primary-600 px-4 py-4 md:px-5">
          <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-primary-100">
            <i className="ri-archive-2-line text-[12px]"></i> 事件脉络 · 全网追踪专题
          </span>
          <div className="mt-2 flex flex-wrap items-end justify-between gap-3">
            <h2 className="font-heading text-xl leading-tight text-background-50 md:text-2xl">
              「{featuredTopic.subject}」时间线还原
            </h2>
            <div className="flex items-center gap-2">
              <span className="flex items-center gap-1 rounded-full bg-background-50/15 px-2.5 py-1 text-[11px] text-background-50">
                <i className="ri-fire-fill text-[11px]"></i> 热度 {featuredTopic.heat}
              </span>
              <span className="rounded-full bg-background-50/15 px-2.5 py-1 text-[11px] text-background-50">{featuredTopic.lastUpdate}更新</span>
            </div>
          </div>
        </div>

        <div className="p-4 md:p-5">
          <div className="mb-4 flex flex-wrap items-center gap-2">
            {featuredTopic.sources.map((s) => (
              <span key={s} className="rounded-full border border-background-300/70 bg-background-100/50 px-2.5 py-1 text-[11px] text-foreground-600">
                <i className="ri-link-m mr-1 text-[11px]"></i>{s}
              </span>
            ))}
          </div>

          <div className="relative">
            <div className="absolute bottom-0 left-[11px] top-2 hidden w-px bg-gradient-to-b from-primary-200 via-background-300 to-background-200 md:block" />
            <div className="space-y-4">
              {featuredTopic.steps.map((st, i) => (
                <div key={i} className="relative flex gap-4">
                  <div className="hidden shrink-0 flex-col items-center md:flex">
                    <span className={`z-10 flex h-[23px] w-[23px] items-center justify-center rounded-full border-2 text-[10px] ${i === featuredTopic.steps.length - 1 ? 'border-primary-500 bg-primary-500 text-background-50' : 'border-background-300 bg-background-50 text-foreground-500'}`}>
                      <i className={i === featuredTopic.steps.length - 1 ? 'ri-check-line text-[10px]' : ''}></i>
                    </span>
                  </div>
                  <div className="min-w-0 flex-1 rounded-xl border border-background-200/60 bg-background-100/40 p-3.5 transition-colors hover:border-primary-200">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-mono text-[12px] font-bold text-primary-600">{st.time}</span>
                      <span className="text-[13px] font-semibold text-foreground-900">{st.label}</span>
                      {i === featuredTopic.steps.length - 1 && (
                        <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-800">进行中</span>
                      )}
                    </div>
                    <p className="mt-1 text-[12px] leading-relaxed text-foreground-600">{st.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}